
import styled from 'styled-components/macro'
import Wrapper from '../components/wrapper/wrapper'
import Filters from '../ui-kit/filters/filters'
import TitleBlock from '../components/title-block/title-block'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { categoriesStatusSelect, fetchCategoriesCards, saveScrollPosition, setCurrentPage, setFilter, subCategoriesFilterSelect } from '../redux/slices/categories'
import VerticalFilters from '../components/vertical-filters/vertical-filters'
import CardPreview from '../components/Card/card-preview'
import defaultAvatar from './../assets/cardPhoto.png'
import defaultToy from './../assets/defaultToy.png'
import { selectIsAuth } from '../redux/slices/auth'
import { useEffect, useState } from 'react'
import { usePagination } from '../hooks/usePagination'
import { categoriesCardsSelect, categoriesFilterSelect, categoriesPagingSelect } from '../redux/slices/categories'
import LoaderCircle from '../ui-kit/loader-circle/loader-circle'
import VerticalFiltersMobile from '../components/vertical-filters-mobile/vertical-filters-mobile'

const TitleWrapper = styled.div`
  margin-bottom: 16px;

   @media (max-width: 1024px) {
      margin: 20px -112px 16px;
    }

    @media (max-width: 577px) {
      margin: 20px -10px 0;
    }
`

const MarketPart = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr; 
  justify-content: space-between;
  grid-gap: 30px;

  @media (max-width: 577px) {
    margin: 0;
    padding-top: 26px;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 15px;
    grid-template-rows: 269px;
    grid-auto-rows: 269px;

    & > a {
      overflow: hidden;
    }
  }
`

const Content = styled.div`
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
  gap: 30px;

  @media (max-width: 1024px) {
    margin: 0;
    padding-top: 26px;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 15px;
    grid-template-rows: 269px;
    grid-auto-rows: 269px;
    flex-direction: column;

    & > a {
      overflow: hidden;
    }
  }

   @media (max-width: 577px) {
    padding-top: 0;
  }
`

export const PaginationWrapper = styled.div`
  margin-top: 20px;
  width: 100%;
`

export const MarketWrapper = styled.div`
  flex: 1 1 auto;
`

const CategoriesPage = () => {
  const { t } = useTranslation()
  const isAuth = useSelector(selectIsAuth);
  const cards = useSelector(categoriesCardsSelect);
  const filter = useSelector(categoriesFilterSelect);
  const paging = useSelector(categoriesPagingSelect);
  const isLoading = useSelector(categoriesStatusSelect);
  const subCategories = useSelector(subCategoriesFilterSelect);

  const dispatch = useDispatch();
  const [isShowFilter, setIsShowFilter] = useState(false)
  
  const { paginationComponent } = usePagination({
    totalPages: paging.pages,
    initialPage: paging.currentPage,
    onPageChange: (nextPage) => { dispatch(setCurrentPage(nextPage)) }
  });

  const savePosition = () => {
    dispatch(saveScrollPosition(window.scrollY))
  }

  const filterSubmitHandler = (filter) => {
    dispatch(setFilter(filter));
  }

  useEffect(() => {
    dispatch(fetchCategoriesCards())
  }, [dispatch, filter.cathegory]);
  return (
      <Wrapper>
        <TitleWrapper>
            <TitleBlock title={t('cathegory_menu')} currentFIlter={filter} setShowFilter={setIsShowFilter} isShowFilter={isShowFilter}/>
        </TitleWrapper>
        {isShowFilter && 
            <Filters
              currentFIlter={filter}
              onSubmit={filterSubmitHandler}
            />
        }
        {isLoading === 'loading' ?
          <LoaderCircle/>
              :
          <Content>
            <VerticalFilters items={subCategories} currentFIlter={filter}/>
            <VerticalFiltersMobile items={subCategories} currentFIlter={filter}/>
            <MarketWrapper>
              <MarketPart>
                {cards?.map((obj) => {
                  return (  
                    <div key={obj._id} onClick={savePosition}>
                      <CardPreview 
                          key={obj._id}
                          altWork={obj.name} 
                          imageWork={obj.imgUrl ?`https://toobears.com/api/${obj.imgUrl[0]}` : defaultToy}
                          avatar={`https://toobears.com/api/${obj.author.avatarUrl}` || defaultAvatar}
                          shopName={obj.author.shopname || `${obj.author.username} ${obj.author.surname}`}
                          nameWork={obj.name}
                          price={obj.price + ' ' + obj.currency}
                          size={obj.size + 'cm'}
                          likeActive={obj.like.includes(isAuth && isAuth._id)}
                          status={obj.status}  
                          link={`/card/${obj._id}`}  
                      />
                    </div>
                  )})} 
              </MarketPart>
              <PaginationWrapper>
                {paginationComponent}
              </PaginationWrapper>
            </MarketWrapper>
          </Content>
        }
      </Wrapper>
  )
}

export default CategoriesPage